
export const APP_BUILD_HEADER = 'X-App-Build';

let ownBuild: string | null = null;
let stale = false;
let reloading = false;

export function initAppBuild(entryUrl: string): void {
  if (!import.meta.env.PROD) return;
  ownBuild = new URL(entryUrl).pathname;
}

export function noteServerBuild(serverBuild: string | null): void {
  if (stale || !ownBuild || !serverBuild) return;
  stale = serverBuild !== ownBuild;
}

export function markAppStale(): void {
  stale = true;
}

export function isAppStale(): boolean {
  return stale;
}

export function reloadForNewBuild(): void {
  reloading = true;
  window.location.reload();
}

export function isReloadingForNewBuild(): boolean {
  return reloading;
}
